import { CalendarDays } from "lucide-react";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

// Shared custom day-range picker for riders dropdowns: pick "from day" and "to day"
// out of the actually-available report dates (e.g. day 14 → day 18) and aggregate cumulatively.
export const RiderDayRange = ({ dates = [], range, setRange }) => {
  const sorted = [...(dates || [])].sort();
  if (sorted.length < 2) return null;
  const NONE = "__none__";
  return (
    <div className="flex items-center gap-1.5" data-testid="rider-range">
      <Select value={range.from || NONE} onValueChange={(v) => setRange((p) => ({ ...p, from: v === NONE ? "" : v }))}>
        <SelectTrigger data-testid="rider-range-from" className="w-36 h-9 gap-1">
          <CalendarDays className="h-3.5 w-3.5 text-slate-400" />
          <SelectValue placeholder="من يوم…" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>من يوم…</SelectItem>
          {sorted.map((d) => <SelectItem key={d} value={d}>{`يوم ${d}`}</SelectItem>)}
        </SelectContent>
      </Select>
      <span className="text-slate-400 text-sm">→</span>
      <Select value={range.to || NONE} onValueChange={(v) => setRange((p) => ({ ...p, to: v === NONE ? "" : v }))}>
        <SelectTrigger data-testid="rider-range-to" className="w-36 h-9 gap-1">
          <CalendarDays className="h-3.5 w-3.5 text-slate-400" />
          <SelectValue placeholder="إلى يوم…" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>إلى يوم…</SelectItem>
          {sorted.map((d) => <SelectItem key={d} value={d}>{`يوم ${d}`}</SelectItem>)}
        </SelectContent>
      </Select>
      {(range.from || range.to) && (
        <Button variant="ghost" size="sm" data-testid="rider-range-clear" className="h-9 px-2 text-slate-400"
          onClick={() => setRange({ from: "", to: "" })}>الكل</Button>
      )}
    </div>
  );
};
